<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a>FROM LIGHTNINGS</h1>
<h1 class="title0">TO MiGs</h1>
<p class="title1">A Cold War Pilot’s Operations,</p>
<p class="title1_0">Test Flying &amp; An Airspeed Record</p>
<p class="auth">SQUADRON LEADER RUSS PEART AFC WKhM</p>
<div class="img_containert">
<img alt="image" src="images/p003_01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?4fc94220